import React from 'react';

export default function IconRadioSelect({
  selected = false,
  disabled = false,
}) {
  return selected ? (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="7.5" fill="#00AB6B" />
      <path
        d="M7 10L8.55751 11.6873C8.71593 11.8589 8.98445 11.8668 9.15269 11.7048L13 8"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  ) : (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10"
        cy="10"
        r="6.875"
        stroke="#CBCBCB"
        fill={disabled ? '#F7F7F7' : 'none'}
        strokeWidth="1.25"
      />
    </svg>
  );
}
